
import React, { useState, useEffect, useContext } from "react";
import quizThumb from '../../assets/images/quiz-default.jpg';
import eqa from '../../assets/images/eqa-img.jpg';
import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
import Header from "../../components/dashboard/header";

import { contentContext } from "../../context/contentContext";
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";
import { useNavigate, Link, useLocation } from "react-router-dom";
import DataTable from 'react-data-table-component';
import TableLoader from "../../components/tableLoader";
import Loader from "../../components/loader";
const ClinicanHome = () => {
    const navigate = useNavigate();
    const [quizzes, setQuizzes] = useState([]);
    // const [winners, setWinners] = useState([]);
    // const [imageCloudfront, setImg] = useState(false);
    const [quizzesFiltered, setQuizzesFiltered] = useState([]);
    const [quizzesType, setQuizzesType] = useState('all');
    const [loadContent, setLoadContent] = useState(false);
    const [type, setType] = useState("")
    const {  isLoading, setIsLoading,  imageCloudfront, setImg, winners, setWinners } = useContext(contentContext)
    const capitalizeFirstLetter = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
    const columns = [
        // {
        //     name: 'Sl No',
        //     selector: (row, index) => index + 1
        // },
        {
            name: 'Quiz',
            selector: row => capitalizeFirstLetter(row?.quizname),
            sortable: true,
        },
        {
            name: 'Image',
            cell: (props) =>
                <div className="question">

                    
                    {props?.files && props?.files.length > 0 && <div className="question_left">
                      
                        <img src={`${imageCloudfront}${props?.files[0]?.sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=100`} /></div>}


                </div>
        },
        
        {
            name: 'Participants',
            selector: row => row?.participants ?? 0,
            sortable: true,
        },


        // {
        //     name: 'Started On',
        //     cell: (props) => props?.startDate ? moment.utc(props?.startDate).format('DD MMM YYYY, h:mm A') : "",
        // },
        // {
        //     name: 'Ended On',
        //     cell: (props) => props?.endDate ? moment.utc(props?.endDate).format('DD MMM YYYY, h:mm A') : "",
        // },
        {
            name: 'Announced on',
            cell: (props) => props?.WinnerAnnouncedOn ? moment.utc(props?.WinnerAnnouncedOn).format('DD MMM YYYY, HH:mm A') : "",
        },
        {
            name: 'Winner',
            cell: (props) =>

                <div className="winner">
                    <span className="material-symbols-outlined icon">
                        trophy
                    </span> {props.name}
                </div>
            ,


        },
    ];

    // useEffect(() => {

    //     if (window.site === undefined) {
    //         setTimeout(() => {
    //             if (window?.site && window?.site?.common && window?.site?.common?.imageCloudfront) {
    //                 setImg(window.site.common.imageCloudfront)
    //             }
    //         }, 1000);
    //     }else {
    //             siteInfo()
    //     }
    //     if (window?.site && window?.site?.common && window?.site?.common?.imageCloudfront) {
    //         setImg(window.site.common.imageCloudfront)
    //     }


    // }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        GetQuizInfo()
        // winnersInfo()
     //   siteInfo()
    }, []);

    const siteInfo = async () => {

        try {
            const response = await tmdbApi.configData();
            setImg(response?.result[0]?.common?.imageCloudfront)
        } catch {
            console.log("error");
            setLoadContent(true)
        }
    };

    const winnersInfo = async () => {

        try {
            const response = await tmdbApi.winnersInfo();
            setWinners(response?.result);
        } catch {
            console.log("error");
            setLoadContent(true)
        }
    };


    const GetQuizInfo = async () => {
        setIsLoading(true)
        try {
            const response = await tmdbApi.quizHomeInfo();
            setQuizzes(response?.result);
            setQuizzesFiltered(response?.result)
            setLoadContent(true)
            setIsLoading(false)
        } catch {
            console.log("error");
            setLoadContent(true)
        }
    };

    // const GetQuizFilterInfo = async (status) => {

    //     try {
    //         const response = await tmdbApi.quizHomeFilterInfo(status);
    //         setQuizzes(response?.result);
    //         setQuizzesFiltered(response?.result)
    //         setLoadContent(true)
    //     } catch {
    //         console.log("error");
    //         setLoadContent(true)
    //     }
    // };

    const handleRegister = (e, quizinfo) => {
        // console.log('register ', quizinfo)
        localStorage.setItem('q', JSON.stringify(quizinfo))
        navigate({
            pathname: "/quiz",
            state: { quizinfo }
        });
    }
    const handleFilter = (e, type) => {
        e.preventDefault();

        // Set the selected quiz type
        setQuizzesType(type);
        if (type == "all") {
            setQuizzesFiltered(quizzes)
        } else {
            // Filter quizzes based on the type
            const FilteredData = quizzes?.filter((item) => item?.quizType === type);
            // console.log("Filtered Data:", FilteredData);

            // Update the quizzes state with the filtered data
            setQuizzesFiltered(FilteredData);
        }

    };

    const customNoRecords = (type) => {
        return (
            quizzesType !== "all" && 
            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No {type} Found</p>
                    </div> </div>
        )
    }



    return (

        <main>
            <Header />

            <div className="wrapper client_wrapper">
         
            <div className="vertical-menu client_vertical_menu">

                <div data-simplebar className="h-100">

                    <div id="sidebar-menu">
                     
                        <ul className="metismenu list-unstyled" id="side-menu">
                            
                            <li>
                                <a href="javascript: void(0);" className=" waves-effect">
                                    <i className="material-symbols-outlined"> video_library </i>
                                    <span key="t-dashboards">CPC Recordings</span>
                                </a>
                            
                            </li>

                            <li>
                                <a href="javascript: void(0);" className="waves-effect">
                                    <i className="material-symbols-outlined"> category </i>
                                    <span key="t-layouts">Lecture Library</span>
                                </a>
                               
                            </li>
                           

                        </ul>
                    </div>
                
                </div>
            </div>
           
                <div className="content_blockk">
                {isLoading?<Loader/>:
                    <div className="quiz_tab">
                        {/* <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <button className={`nav-link ${quizzesType == "all" && `active`}`} onClick={(e) => handleFilter(e, 'all')} >All</button>
                                <button className={`nav-link ${quizzesType == "Self Assessment" && `active`}`} onClick={(e) => handleFilter(e, 'Self Assessment')} >Self Assessment</button>
                                <button className={`nav-link ${quizzesType == "Competitive" && `active`}`} onClick={(e) => handleFilter(e, 'Competitive')} >Competitive</button>
                              
                                <button className={`nav-link ${quizzesType == "winners" && `active`}`} onClick={(e) => setQuizzesType('winners')} >Winners</button>
                            </div>
                        </nav> */}
                        <div className="tab-content" id="nav-tabContent">

                            {quizzesType != "winners" ?
                                <div className="quiz_items row">
                                        {/* {quizzesType === "all" && <div className="col-md-3 eta">
                                            <div className="item">
                                                <div className="img"><img
                                                        src={eqa} />
                                                </div>
                                                <div className="info">
                                                    <h3>EQA</h3>
                                                    <div className="btns">
                                                        <div className="date">
                                                            <a href="https://visa-app.d3ppy3iytx6ior.amplifyapp.com/summary" className="border_btn">Summary</a>
                                                     
                                                        </div>
                                                        <a href="https://visa-app.d3ppy3iytx6ior.amplifyapp.com/" className="join_now">Join Now <span className="material-symbols-outlined icon">arrow_forward</span></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>} */}

                                    {quizzesFiltered?.length > 0 && quizzesFiltered.map((item, index) => {
                                        return (
                                            <div className="col-md-3" key={index}>
                                                <div className="item">
                                                    <div className="img">
                                                        <span className="count">{item?.questionsCount || 0} Questions</span>
                                                        <span className="users">
                                                            <span className="material-symbols-outlined icon"> group </span>
                                                            <span className="num">{item?.participants || 0}</span>
                                                        </span>
                                                        {item?.files && item?.files.length > 0 ?
                                                            <img src={imageCloudfront + item?.files[0]?.sourcepath.replace(/ /g, "%20") + `?auto=compress,format&width=400`} />
                                                            : <img src={quizThumb} />}

                                                    </div>
                                                    <div className="info">
                                                        <h3>{item?.name || ""}</h3>

                                                        <div className="btns">
                                                            <div className="date">
                                                            {item?.quizType === "Self Assessment" ? <div className="tooltip2" data-text="Self Assessment">
                                                                    <span className="material-symbols-outlined self_assessment "> list_alt_check </span>
                                                                </div> : <div className="tooltip2" data-text="Competitive">
                                                                    <span className="material-symbols-outlined competitive"> workspace_premium </span>
                                                                </div>}
                                                                {item?.quizType == "Competitive" &&
                                                                    <div>
                                                                        <div className="left">
                                                                            <p>End Date</p>
                                                                            <p><span> {item?.endDate && moment.utc(item?.endDate).format('DD MMM, YYYY')}</span></p>
                                                                        </div>
                                                                        {/* <div className="left">
                                                                <p>Start Date</p>
                                                                <p><span> {item?.startDate && moment.utc(item?.startDate).format('DD MMM, YYYY')}</span></p>
                                                            </div>
                                                            <div className="right">
                                                                <p>End Date</p>
                                                                <p><span> {item?.endDate && moment.utc(item?.endDate).format('DD MMM, YYYY')}</span></p>
                                                            </div> */}
                                                                    </div>}
                                                              
                                                            </div>

                                                            {item?.status?.toLowerCase() == "active" &&
                                                                <div onClick={(e) => handleRegister(e, item)} className="join_now">Join Now <span className="material-symbols-outlined icon">
                                                                    arrow_forward
                                                                </span></div>}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}


                                    {/* {quizzesType==="winners" &&     <div className="col-md-3">
                                            <h1>Hellooooo</h1>
                                        </div> } */}

                                    {loadContent && quizzesFiltered?.length == 0 && quizzesType !== "winners" && customNoRecords('Quizzes')}


                                </div>
                                :
                                <div className="winners_block">


<DataTable
  columns={columns}
  className="table winner_dable"
  keyField="_id"
  data={winners}
  direction="auto"
  highlightOnHover
  fixedHeaderScrollHeight="300px"
  pagination
  responsive
  persistTableHead
  striped
  noDataComponent={customNoRecords('Records')}
  paginationTotalRows={winners?.length}
  paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
  paginationPerPage={15} // Set the default number of rows per page
  paginationComponentOptions={{
    rowsPerPageText: 'Per page:',
    rangeSeparatorText: 'of',
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: 'All',
  }}
  progressComponent={<TableLoader />}
/>


                                </div>}

                        </div>
                    </div>
 }
                </div>
           
            </div>
        
            <Footer />
        </main>

    );
};

export default ClinicanHome;
